import { Getters } from 'vuex-smart-module';
import ClientsState from './state';

export default class ClientsGetters extends Getters<ClientsState> {}
